import { render, staticRenderFns } from "./main-page.vue?vue&type=template&id=ff8c5e54&scoped=true&"
import script from "./main-page.vue?vue&type=script&lang=js&"
export * from "./main-page.vue?vue&type=script&lang=js&"
import style0 from "./main-page.vue?vue&type=style&index=0&id=ff8c5e54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8c5e54",
  null
  
)

export default component.exports